export default require('./Performance').default;
